import { Mic, X } from "lucide-react";
import { FC } from "react";
import { AgentWidgetConfig } from "../../apis/agent.api";
import { Button } from "../../components/ui/button";
import ChatIcon from "../../components/ui/svgs/chat-icon";
import { WidgetScene } from "../types/widget-scenes";
import AgentAvatar from "./agent-avatar";

export interface iChoiceProps {
  setWidgetStage: (v: WidgetScene) => void;
  agentId: string;
  config: AgentWidgetConfig;
}

const Choice: FC<iChoiceProps> = ({ setWidgetStage, config }) => {
  const onClose = () => setWidgetStage(WidgetScene.INCOMING_CALL);
  const selectConversationType = (t: WidgetScene.CALL | WidgetScene.CHAT) =>
    setWidgetStage(t);

  return (
    <div
      className="bg-white shadow-widget text-center min-w-[360px] rounded-[20px] flex 
   gap-4 h-full"
    >
      <Button
        onClick={onClose}
        className="rounded-full absolute top-2 right-2 bg-[rgba(255,255,255,0.14)] border-none size-[27px]"
        variant="outline"
        size="icon"
      >
        <X />
      </Button>

      <div className="bg-green-500 rounded-full size-[10px] absolute top-2 left-2 z-[999999999999]" />

      <div className="flex flex-col">
        <AgentAvatar
          className="w-[120px] object-contain rounded-none h-full rounded-l-[16px]"
          config={config}
        />
      </div>

      <div className="p-4 flex flex-col gap-4">
        <div />
        <p className="text-left">
          Hey, {config.ai_agent?.agent_name} here if you need any help; <br />{" "}
          I&apos;m online to..
        </p>

        <div className="flex gap-2 w-full">
          <Button
            style={{
              backgroundColor: config?.main_color ?? "#0051ff",
              color: config?.text_color ?? "white",
            }}
            onClick={() => selectConversationType(WidgetScene.CHAT)}
            size={"sm"}
            className="flex-1"
          >
            Text chat <ChatIcon />
          </Button>
          <Button
            onClick={() => selectConversationType(WidgetScene.CALL)}
            size={"sm"}
            variant={"medium"}
            className="flex-1"
          >
            Voice call
            <Mic />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Choice;
